<script>
  //colors: Primary(#4e73df),Success(#1cc88a),Info(#36b9cc),Warning(#f6c23e),Danger(#e74a3b),Secondary(#858796),Light(#f8f9fc),Dark(#5a5c69)
  export let color = 'primary';
  export let title;
  export let ico;
</script>

<div class="card border-left-{color} shadow h-100 py-2">
    <div class="card-body">
        <div class="row no-gutters align-items-center">
            <div class="col mr-2">
                <div class="text-s font-weight-bold text-{color} text-uppercase mb-1">
                    {title}
                </div>
                <slot/>
            </div>
            <div class="col-auto">
                <i class="{ico}"></i>
            </div>
        </div>
    </div>
</div>
